import { POST } from '@/utils/axios'

export const getProfileChartData = async formData =>
  await POST('/question/profile-chart', formData)

export const submitAnswer = async formData =>
  await POST('survey-enrollment/next-step', formData)
